// @helpers
import { recordLinkV2 } from 'utilities/tagging';

// @constants
import { CRYPTO_ASSETS_BANNER_ACTION_EVENT, CRYPTO_ASSETS_BANNER_CATEGORY_EVENT } from 'constants/tagging';

export const taggingBuyCryptoAssets = () => {
    recordLinkV2({
        categoriaEvento: CRYPTO_ASSETS_BANNER_CATEGORY_EVENT,
        accionEvento: CRYPTO_ASSETS_BANNER_ACTION_EVENT,
        component: CRYPTO_ASSETS_BANNER_ACTION_EVENT,
        etiquetaEvento: 'buy',
        action: "click",
        format: "button",
        element: "buy"
    });
}
